import * as React from "react";
import { Checkbox as AtlasCheckbox } from "@wellsky/atlas-ui-react";


interface CheckboxProps extends Omit<React.ComponentProps<typeof AtlasCheckbox>, "onChange"> {
  onCheckedChange?: (checked: boolean) => void;
}

function Checkbox({
  className,
  onCheckedChange,
  ...props
}: CheckboxProps) {
  return (
    <AtlasCheckbox
      data-slot="checkbox"
      className={className}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        onCheckedChange?.(e.target.checked);
      }}
      {...props}
    />
  );
}

export { Checkbox };
